import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ed8fa4e&"
import script from "./index.vue?vue&type=script&lang=coffee&"
export * from "./index.vue?vue&type=script&lang=coffee&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports